import { IconSortAsc, IconSortDesc } from '@/icons';
import { useCallback } from 'react';

interface Props {
  selectedSort: string;
  wantedSort: string;
  sortDirection: string;
}

export const useAscOrDescIcon = () => {
  return useCallback(({ selectedSort, wantedSort, sortDirection }: Props) => {
    const icon = sortDirection === 'asc' ? <IconSortAsc /> : <IconSortDesc />;

    if (selectedSort === wantedSort) {
      return icon;
    }
    return <IconSortAsc />;
  }, []);
};
